import {
  AlertStatus,
  AlertStatusSchema,
} from '@/task-manager/entities/alert-status';

export function alertStatusMapper(data: string): AlertStatus | undefined {
  const result = AlertStatusSchema.safeParse(data);
  return result.success ? result.data : undefined;
}
